import React, { useEffect, useState } from 'react';
import { extendLoginToken, getSessionTime } from '@api/api';
import { isLocal, isDev } from '@common/utils/env';
import {
  LOGIN_TOKEN_DURATION,
  LOGIN_EXPIRE_ALERT_TIME,
  initLoginTimeEvent,
  clearLoginTimeEvent,
  checkLoginAutoExtend,
  isTablet,
  extendLoginTimer,
  calculateLoginTime,
} from '@common/utils';

let loginDuration = LOGIN_TOKEN_DURATION,
  loginExpireAlertTime = LOGIN_EXPIRE_ALERT_TIME;

const changeExpireTime = (expireTime, isTest = false) => {
  if (isTest) {
    loginDuration = expireTime * 1000;
    loginExpireAlertTime = (expireTime / 3) * 1000;
  } else {
    loginDuration = expireTime;
  }
  // cleanTimer();
  window._cleanTimer();
  window._startTimer();
};

const SnbLoginTimer = () => {
  const { isLoggedIn, logout } = $hooks.useUser();
  const { info: toastInfo } = $hooks.useToast();
  const { alert, hide } = $hooks.useModal();

  // Robin: loginTimerInfo Store 관리 시, App.js 매초마다 렌더링 문제로 window.loginTimerInfo 사용
  const [timerInfo, setTimerInfo] = useState(
    window.loginTimerInfo || {
      validTime: '00:00',
      isInitialized: false,
    },
  );
  const { validTime, isInitialized } = timerInfo;

  const getDiffTime = cur => {
    if (cur && cur.length === 14) {
      const start = new Date();
      const year = cur.slice(0, 4);
      const month = cur.slice(4, 6);
      const day = cur.slice(6, 8);
      const hour = cur.slice(8, 10);
      const min = cur.slice(10, 12);
      const sec = cur.slice(12, 14);
      const end = new Date(`${year}/${month}/${day} ${hour}:${min}:${sec}`);

      return end.getTime() - start.getTime();
    } else {
      return new Date().getTime();
    }
  };

  const getOtherSystemExtendTime = cur => {
    if (cur && cur.length === 14) {
      const year = cur.slice(0, 4);
      const month = cur.slice(4, 6);
      const day = cur.slice(6, 8);
      const hour = cur.slice(8, 10);
      const min = cur.slice(10, 12);
      const sec = cur.slice(12, 14);
      return new Date(
        `${year}/${month}/${day} ${hour}:${min}:${sec}`,
      ).getTime();
    } else {
      return new Date().getTime();
    }
  };

  const checkSessionExtendByOtherSystem = () => {
    if (window._intervalNo !== '') {
      clearInterval(window._intervalNo);
    }
    window._intervalNo = setInterval(async () => {
      const response = await getSessionTime();
      const isSuccess = $utils.checkApiSuccess(response);
      const data = $utils.getApiData(response);

      if (isSuccess && data) {
        // const diffTime = getDiffTime(data);
        // const remain = window.expireTime - new Date().getTime();
        //
        // if (diffTime > remain) {
        //   if (diffTime > loginDuration) {
        //     changeExpireTime(loginDuration);
        //   } else {
        //     changeExpireTime(diffTime);
        //   }
        // } else if (diffTime < remain) {
        //   if (remain > loginDuration) {
        //     changeExpireTime(loginDuration);
        //   } else {
        //     changeExpireTime(remain);
        //   }
        // } else {
        //   changeExpireTime(loginDuration);
        // }

        const otherSystemExtendTime =
          getOtherSystemExtendTime(data) + loginDuration;
        const remain = window.expireTime;

        if (otherSystemExtendTime > remain) {
          const isBig =
            otherSystemExtendTime - new Date().getTime() > loginDuration;
          if (isBig) {
            window.expireTime = calculateLoginTime(loginDuration);
          } else {
            window.expireTime = otherSystemExtendTime;
          }
        }
      }
    }, 20 * 60 * 1000);
  };

  const changeLoginTimerInfo = payload => {
    const newLoginTimerInfo = { ...timerInfo, ...payload };
    setTimerInfo(newLoginTimerInfo);
    window.loginTimerInfo = newLoginTimerInfo;
  };

  const formatMinuteTime = time => {
    if (time > 0) {
      const minute = Math.floor(time / 1000 / 60);
      const second = Math.floor((time - minute * 1000 * 60) / 1000);
      const minuteText =
        minute.toString().length > 2
          ? `${minute}`.slice(-3)
          : `0${minute}`.slice(-2);
      const secondText = `0${second}`.slice(-2);

      return `${minuteText}:${secondText}`;
    } else {
      return '00:00';
    }
  };

  const cleanTimer = isTrue => {
    if (!isTrue) changeLoginTimerInfo({ isInitialized: false });
    clearInterval(window.loginTokenTimer);
    window.loginTokenTimer = null;
    window.isExpireAlert = false;
    window.expireTime = null;

    clearInterval(window._intervalNo);
  };

  const startTimer = () => {
    if (window.loginTokenTimer) clearInterval(window.loginTokenTimer);
    window.expireTime =
      window.expireTime > 0
        ? window.expireTime
        : calculateLoginTime(loginDuration);
    window.loginTokenTimer = setInterval(checkValidTime, 1000);
    window.isExpireAlert = false;
    changeLoginTimerInfo({ isInitialized: true });
    checkValidTime();

    // 타연계시스템에서 세션연장 확인 PC
    if (!isTablet) checkSessionExtendByOtherSystem();
  };

  const renewLoginTimer = () => {
    // startTimer();
    window.expireTime = calculateLoginTime(loginDuration);
    window.isExpireAlert = false;
    changeLoginTimerInfo({ isInitialized: true });
  };

  const extendToken = async (options = {}) => {
    await extendLoginTimer(options);

    renewLoginTimer();
    toastInfo('로그인시간이 연장되었습니다.');
  };

  const checkValidTime = () => {
    const remainingTime = calculateLoginTime(window.expireTime);

    // 로그인 만료 시 - 타이머 종료 및 강제 logout 처리
    if (remainingTime <= 0) {
      cleanTimer(true);

      // 연장팝업 닫기
      hide(window._hideIndex);

      // ExpireLoginTimer.js로 이동
      // alert({
      //   message: '로그인 시간 만료로 자동 로그아웃 되었습니다.',
      // });
      logout(true);
    }

    // 로그인 만료시간 알림 - ${LOGIN_EXPIRE_ALERT}분 남았을 때
    else if (!window.isExpireAlert && remainingTime <= loginExpireAlertTime) {
      window.isExpireAlert = true;
      changeLoginTimerInfo({ isExpireAlert: true });

      const alertInfo = alert({
        message:
          '로그인 종료 10분 전입니다. 10분 뒤 자동 로그아웃됩니다. 시간을 연장하시려면 ‘연장’ 버튼을 눌러주세요.',
        okLabel: '연장',
        onClose: () => {
          // '연장' 클릭 시점에 만료가 되지 않았으면 연장
          const remainingTime = calculateLoginTime(window.expireTime);
          const isNotExpired = remainingTime > 0;
          if (isNotExpired) extendToken();
          window.isExpireAlert = false;
        },
      });
      window._hideIndex = alertInfo?.index;
    }

    // 로그인 시간 자동 연장 체크
    checkLoginAutoExtend();

    const validTime = formatMinuteTime(remainingTime);
    changeLoginTimerInfo({ validTime });
  };

  useEffect(() => {
    window._startTimer = startTimer;
    window._cleanTimer = cleanTimer;

    // 타연계시스템에서 세션연장위해 메뉴등록 추가
    if (!isTablet) {
      extendLoginToken();
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn && !isInitialized) initLoginTimeEvent();
    else if (!isLoggedIn) clearLoginTimeEvent();
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isInitialized) changeLoginTimerInfo({ isInitialized: true });

    return cleanTimer;
  }, []);

  useEffect(() => {
    if (isInitialized && !window.loginTokenTimer) startTimer();
  }, [isInitialized]);

  return (
    <>
      <div className="h_time hicon">
        {(isLocal || isDev) && (
          <div
            style={{
              display: 'inline-block',
              width: '100%',
              marginBottom: '10px',
            }}
          >
            <div>세션시간변경(초단위)</div>
            <input
              id="expireTimerInput"
              type="tel"
              style={{
                border: '1px solid gray',
                width: '100px',
                height: '2rem',
              }}
            />
            <button
              className="extend"
              style={{ height: '2rem' }}
              onClick={() => {
                changeExpireTime(
                  document.getElementById('expireTimerInput').value,
                  true,
                );
              }}
            >
              변경
            </button>
          </div>
        )}
        <span className="mgl-8 mgr-5">남은시간</span>
        <em>{validTime}</em>
        <button className="extend" onClick={extendToken}>
          연장
        </button>
      </div>
    </>
  );
};

export default SnbLoginTimer;
